import React, { useRef, useState } from 'react'
import { css, useTheme } from '@emotion/react'
import { useForm } from 'react-hook-form'
import { Button, Card } from '../base-ui'
import { MediaQuery } from '../base-ui/Utility'
import { useTranslation } from 'next-i18next'

function OrderForm({ defaultValues = null, readonly = false }) {
    const [message, setMessage] = useState('')
    const [success, setSuccess] = useState(false)
    const theme = useTheme()
    const submitting = useRef(false)
    const { t } = useTranslation(['common'])
    const {
        register,
        formState: { errors },
        handleSubmit
    } = useForm({ defaultValues })
    const onSubmit = async (data) => {
        if (submitting.current) return
        submitting.current = true
        try {
            const formData = new FormData()
            for (let k in data) {
                formData.append(k, data[k])
            }

            const response = await fetch('/api/forms?id=545', {
                method: 'POST',
                body: formData,
                headers: { contentType: null }
            })
            let responseObject = await response.json()
            if (response.status === 200) {
                setMessage('')
                setSuccess(t('با تشکر در اسرع وقت با شما تماس میگیریم'))
            } else if (response.status === 400) {
                if (responseObject.newCaptchaImage) {
                    // resetField('captcha')
                    // setCaptchaImage(responseObject.newCaptchaImage)
                }
                setMessage(responseObject.message)
            }
        } catch (error) {
            console.error('An unexpected error happened occurred:', error)
        } finally {
            submitting.current = false
        }
    }
    const style = css`
        border-radius: 0;
        margin: 2rem auto 0 auto;
        max-width: 64rem;
        form {
            display: flex;
            justify-content: center;
            gap: 2rem 1rem;
            width: 100%;
            flex-wrap: wrap;
            .form-input input {
                height: 45px;
                width: 100%;
                padding: 0.25rem 0.5rem;
                background-color: #ededed;
                border-bottom: 2px solid ${theme.colors.primary};
                line-height: 2rem;
                outline: none;
                &:focus {
                    background-color: #f3f3f3;
                }
            }
            .form-input input::placeholder {
                font-size: 0.9rem;
            }
            label {
                font-size: 0.9rem;
                color: ${theme.colors.medGray};
                display: block;
                margin-bottom: 0.25rem;
            }
            .submit {
                flex-basis: 100%;
                margin: 20px 40%;
                padding: 0.5rem;
                display: flex;
                justify-content: center;
            }
            .error {
                font-size: 0.85rem;
                color: ${theme.colors.danger};
            }
            .required label {
                &:after {
                    content: '*';
                    color: red;
                }
            }
            ${MediaQuery('lg', 'max')} {
                .form-input {
                    flex-basis: 99%;
                }
            }
            ${MediaQuery('lg', 'min')} {
                .form-input {
                    flex-basis: 44%;
                }
            }
        }
    `

    return (
        <Card css={style} bordered>
            {success && (
                <div
                    style={{
                        fontSize: 26,
                        color: 'green',
                        width: '100%',
                        textAlign: 'center'
                    }}
                >
                    {success}
                </div>
            )}
            {!success && (
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-input required">
                        <label>نام</label>
                        <input
                            {...register('firstName', {
                                required: true,
                                disabled: readonly
                            })}
                            aria-invalid={errors.firstName ? 'true' : 'false'}
                        />
                        {errors.firstName?.type === 'required' && (
                            <p className="error" role="alert">
                                {t('این فیلد ضروری است')}
                            </p>
                        )}
                    </div>
                    <div className="form-input required">
                        <label>نام خانوادگی</label>
                        <input
                            {...register('lastName', {
                                required: true,
                                disabled: readonly
                            })}
                            aria-invalid={errors.lastName ? 'true' : 'false'}
                        />
                        {errors.lastName?.type === 'required' && (
                            <p className="error" role="alert">
                                {t('این فیلد ضروری است')}
                            </p>
                        )}
                    </div>
                    <div className="form-input required">
                        <label>موبایل</label>
                        <input
                            {...register('tel', {
                                required: true,
                                // maxLength: 11,
                                disabled: readonly
                            })}
                            type="number"
                            aria-invalid={errors.tel ? 'true' : 'false'}
                        />
                        {errors.tel?.type === 'required' && (
                            <p className="error" role="alert">
                                {t('این فیلد ضروری است')}
                            </p>
                        )}
                    </div>
                    <div className="form-input">
                        <label>ایمیل</label>
                        <input
                            {...register('mail', {
                                required: false,
                                disabled: readonly
                            })}
                        />
                    </div>
                    <div className="form-input">
                        <label>کشور</label>
                        <input
                            {...register('country', {
                                required: false,
                                disabled: readonly
                            })}
                        />
                    </div>
                    <div className="form-input">
                        <label>شهر</label>
                        <input
                            {...register('city', {
                                required: false,
                                disabled: readonly
                            })}
                        />
                    </div>

                    {!readonly && (
                        <Button
                            type="submit"
                            backgroundColor="primary"
                            color="white"
                        >
                            ارسال
                        </Button>
                    )}
                </form>
            )}
            {message && (
                <div
                    style={{
                        fontSize: 20,
                        color: 'red',
                        width: '100%',
                        marginBottom: 10
                    }}
                >
                    {message}
                </div>
            )}
        </Card>
    )
}

export default OrderForm
